import React, { useState, useEffect } from "react";
import { Row } from "antd";
import moment from "moment";

import { Button, DateRangePicker, Select } from "components";
import { localStorageHelper } from "utils";
import { Consultation, ConsultationStatistical } from "./charts";
import {
  WrapperConsultationAction,
  ConsultationGroup,
} from "./Dashboard.style";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { secondSectionActionCreators } from "redux/rootActions";
import { secondSectionDataResponse } from "redux/dashboard/secondSection/secondSectionStates";
import { departmentList4DashboardDataResponse } from "redux/dashboard/departmentList/departmentListStates";

import { httpStatus } from "configs/httpStatus";

const ConsultationContent = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "account",
  });
  const { t: t1 } = useTranslation("translation", {
    keyPrefix: "dashboard",
  });

  const currentLanguage = localStorageHelper.getItem("i18nextLng");

  const dispatch = useDispatch();
  const secondSectionData = useSelector(secondSectionDataResponse);
  const departmentList4DashboardData = useSelector(
    departmentList4DashboardDataResponse
  );

  const [startDate, setStartDate] = useState(
    new Date(moment().startOf("month").format("YYYY/MM/DD"))
  );
  const [endDate, setEndDate] = useState(new Date());
  const [departmentListOptions, setDepartmentListOptions] = useState<any>([]);
  const [consultationData, setConsultationData] = useState([]);
  const [ConsultationStatisticalData, setConsultationStatisticalData] =
    useState({
      body_part_count: 0,
      consultation_count: 0,
      entire_body_part_count: 0,
      mental_count: 0,
    });
  const [departmentID, setDepartmentID] = useState<any>("");

  useEffect(() => {
    if (
      departmentList4DashboardData &&
      departmentList4DashboardData.status === httpStatus.StatusOK
    ) {
      setDepartmentListOptions([
        {
          id: "0",
          name: t1("entire-company"),
          value: "",
        },
        ...departmentList4DashboardData.result.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            value: item.id,
          };
        }),
      ]);
    }
  }, [departmentList4DashboardData]);

  const handleOnChangeDepartmentList = (value: number) => {
    setDepartmentID(value);
  };

  useEffect(() => {
    if (secondSectionData && secondSectionData.status === httpStatus.StatusOK) {
      const {
        data,
        body_part_count,
        consultation_count,
        entire_body_part_count,
        mental_count,
      } = secondSectionData.result;

      setConsultationData(
        data.map((item: any) => {
          return {
            name: item.consultation_name,
            pv: item.consultation_number,
          };
        })
      );
      setConsultationStatisticalData({
        body_part_count,
        consultation_count,
        entire_body_part_count,
        mental_count,
      });
    }
  }, [secondSectionData]);

  useEffect(() => {
    dispatch(
      secondSectionActionCreators.getSecondSectionDataAction({
        start_date: moment(startDate).format("DD-MM-YYYY"),
        end_date: moment(endDate).format("DD-MM-YYYY"),
        designation_id: departmentID,
      })
    );
  }, []);

  return (
    <React.Fragment>
      <WrapperConsultationAction>
        <div>{t1("consultation-content")}</div>
        <ConsultationGroup>
          <Select
            width="100px"
            options={departmentListOptions}
            onChange={handleOnChangeDepartmentList}
            placeholder={t1("entire-company")}
            value={departmentID}
          />
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            locale={currentLanguage}
            maxDate={false}
            minDate={true}
          />
          <Button
            name={t("update")}
            background="#2AC769"
            color="#FFFFFF"
            border="none"
            fontSize={16}
            fontWeight={700}
            width="80px"
            onClick={() => {
              dispatch(
                secondSectionActionCreators.getSecondSectionDataAction({
                  start_date: moment(startDate).format("DD-MM-YYYY"),
                  end_date: moment(endDate).format("DD-MM-YYYY"),
                  designation_id: departmentID,
                })
              );
            }}
          />
        </ConsultationGroup>
      </WrapperConsultationAction>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Consultation data={consultationData} />
        <ConsultationStatistical data={ConsultationStatisticalData} />
      </Row>
    </React.Fragment>
  );
};

export default ConsultationContent;
